import { AutogenLayoutCommissionsRoles } from "./autogen/AutogenLayoutCommissionsRoles";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "commission_role",
    screenName: "Commissions Roles",
    navigateToUrl: "lme/settlement/commissions/CommissionsRoles?mode=update&key="
};

export class CommissionsRoles extends AutogenLayoutCommissionsRoles {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}
